import { useMemo } from 'react'
import DOMPurify from 'dompurify'
import { cn } from '@/lib/cn'
import { plainToRichHtml } from '@/lib/richText'

const ALLOWED_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li', 'h3', 'h4', 'a', 'span', 'blockquote']

/**
 * Mostra um campo de texto rico formatado (negrito, listas, links…), com o
 * HTML sanitizado. Texto antigo, sem marcação, mantém as quebras de linha.
 * Sempre mostra o texto inteiro — regra do sistema: nada cortado com "…".
 */
export function RichHtml({ html, className }: { html: string | null | undefined; className?: string }) {
  const safe = useMemo(() => DOMPurify.sanitize(plainToRichHtml(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  }), [html])
  if (!safe.trim()) return null
  return (
    <div
      className={cn(
        'leading-relaxed [&_p]:my-0.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_h3]:font-semibold [&_h4]:font-semibold [&_a]:text-brand-600 [&_a]:underline break-words',
        className,
      )}
      // HTML sanitizado acima (DOMPurify, allowlist igual à do backend).
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  )
}
